"use client";
import { Controller, UseFormReturn } from "react-hook-form";
import { ListBox } from "cy-fe/src/components/Forms/ListBox";
import { PersonalInfoInputs } from "./models";

export function GenderComboBox({
  form,
}: {
  form: UseFormReturn<PersonalInfoInputs, any, PersonalInfoInputs>;
}) {
  return (
    <Controller
      control={form.control}
      name="gender"
      render={(args) => (
        <ListBox
          label="gender"
          options={genders}
          vSize={"lg"}
          selectedOption={
            (args.field.value &&
              genders.find((x) => x.id === args.field.value)) ||
            null
          }
          onOptionChange={(option) => {
            args.field.onChange(option?.id);
          }}
          data-testid="gender-select"
        />
      )}
      rules={{ required: { message: "Required", value: true } }}
    />
  );
}

const genders = [
  { id: "Male", name: "Male" },
  { id: "Female", name: "Female" },
];
